/*
 * Create a Redux Action with the given Action type, passing in values to match the previously-defined names
 * @sig def :: (String, [String]) -> [*] -> Object
 */
const def = (type, ...argNames) => (...args) => {
    const action = { type }
    argNames.forEach((arg, index) => { action[argNames[index]] = args[index] })
    return action
}

export default def
